// import dynamic from 'next/dynamic';

import _ from 'lodash';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import SectionEventNewspaper from 'src/components/sections/section-event/section-event-newspaper';
import SectionFullH from 'src/components/sections/section-full-h';
import SectionV from 'src/components/sections/section-v';
import { SHOW_COMMEMORATE } from 'src/constants';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import { convertObjPath, timestamp } from 'src/utils/helper';
import { GET } from 'src/utils/services';
import styled from 'styled-components';
import useSWR from 'swr';
import SectionHalfBookcase from '../section-event/section-half-bookcase';
// import SectionYoutube from '../section-youtube/section-youtube';

// const SectionLive = dynamic(import('src/components/sections/section-video/section-live'));

const SectionFive = ({ bannerInews = [], bookcaseHalf, ads }) => {
  const [sectionFiveData, setSectionFiveData] = useState(null);
  const router = useRouter();

  // fetch swr
  const fetcher = url => GET(url);
  // const fetcher = (url: any) => fetch(url).then(res => res.json());
  const { data } = useSWR('/api/v1.0/video/section-one', fetcher, {
    revalidateIfStale: true,
    revalidateOnFocus: false,
    revalidateOnReconnect: true
  });
  const dataLive = data;

  useEffect(() => {
    (async () => {
      try {
        const response = await GET(
          `/api/v1.0/home/section-five${convertObjPath({
            block4: 4,
            block5: 4,
            block6: 4,
            block7: 4,
            block8: 4,
            block9: 4,
            block10: 4
          })}`
        );
        if (!_.isEmpty(response)) setSectionFiveData(response);
      } catch (err) {
        console.error(`${timestamp()} ==========> SECTION_FIVE ERROR :`, err.message);
      }
    })();
  }, []);

  return (
    <>
      <section id='section-11' className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        <div className='row'>
          {!_.isEmpty(sectionFiveData?.block4?.data) && (
            <div className='col-12'>
              <SectionV
                data={sectionFiveData.block4.data}
                heading={sectionFiveData.block4.title}
                path={sectionFiveData.block4.link}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-11',
                  position: 'ใต้:section-spacial (bookcase)',
                  data: {
                    heading: sectionFiveData.block4.title
                  }
                }}
              />
            </div>
          )}
        </div>
      </section>
      <section id='section-12' className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        <div className='row'>
          {!_.isEmpty(sectionFiveData?.block5?.data) && (
            <div className='col-12'>
              <SectionV
                data={sectionFiveData.block5.data}
                heading={sectionFiveData.block5.title}
                path={sectionFiveData.block5.link}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-12',
                  position: 'ใต้:section-11',
                  data: {
                    heading: sectionFiveData.block5.title
                  }
                }}
              />
            </div>
          )}
        </div>
      </section>

      {/* <section id='section-13' className='container'>
        <div className='row'>
          <SectionLive
            data={dataLive}
            //! DATALAYER
            eventDataLayer={{
              type: DATALAYER_TYPE.TRACK_POSITION,
              router: router?.pathname,
              section: 'section-13',
              position: 'ใต้:section-12'
            }}
          />
        </div>
      </section> */}
      <section id='section-14' className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        <div className='row'>
          {!_.isEmpty(sectionFiveData?.block6?.data) && (
            <div className='col-lg-4'>
              <SectionFullH
                data={sectionFiveData.block6}
                count={4}
                path={sectionFiveData.block6.link}
                heading={sectionFiveData.block6.title}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-14',
                  position: 'ใต้:section-13',
                  data: {
                    block: '1',
                    heading: sectionFiveData.block6.title
                  }
                }}
              />
            </div>
          )}
          {!_.isEmpty(sectionFiveData?.block7?.data) && (
            <div className='col-lg-4'>
              <SectionFullH
                data={sectionFiveData.block7}
                count={4}
                path={sectionFiveData.block7.link}
                heading={sectionFiveData.block7.title}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-14',
                  position: 'ใต้:section-13',
                  data: {
                    block: '2',
                    heading: sectionFiveData.block7.title
                  }
                }}
              />
            </div>
          )}

          {!_.isEmpty(sectionFiveData?.block8?.data) && (
            <div className='col-lg-4'>
              <SectionFullH
                data={sectionFiveData.block8}
                count={4}
                path={sectionFiveData.block8.link}
                heading={sectionFiveData.block8.title}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_POSITION,
                  router: router?.pathname,
                  section: 'section-14',
                  position: 'ใต้:section-13',
                  data: {
                    block: '3',
                    heading: sectionFiveData.block8.title
                  }
                }}
              />
            </div>
          )}
        </div>
      </section>
      <section id='section-15' className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        {!_.isEmpty(sectionFiveData?.block9?.data) && (
          <div className='col-12'>
            <SectionV
              data={sectionFiveData.block9.data}
              heading={sectionFiveData.block9.title}
              path={sectionFiveData.block9.link}
              //! DATALAYER
              eventDataLayer={{
                type: DATALAYER_TYPE.TRACK_INDEX,
                router: router?.pathname,
                section: 'section-15',
                position: 'ใต้:section-14',
                data: {
                  heading: sectionFiveData.block9.title
                }
              }}
            />
          </div>
        )}
      </section>
      <SectionHalfBookcase
        bookcaseHalf={bookcaseHalf}
        //! DATALAYER
        eventDataLayer={{
          type: DATALAYER_TYPE.TRACK_POSITION,
          router: router?.pathname,
          section: 'section-new-bookcase',
          position: 'ใต้:section-event'
        }}
      />
      <section id='section-16' className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        {!_.isEmpty(sectionFiveData?.block10?.data) && (
          <div className='col-12'>
            <SectionV
              data={sectionFiveData.block10.data}
              heading={sectionFiveData.block10.title}
              path={sectionFiveData.block10.link}
              //! DATALAYER
              eventDataLayer={{
                type: DATALAYER_TYPE.TRACK_INDEX,
                router: router?.pathname,
                section: 'section-16',
                position: 'ใต้:section-15',
                data: {
                  heading: sectionFiveData.block10.title
                }
              }}
            />
          </div>
        )}
      </section>
      <SectionNewsPapaerWrapper id='section-newspaper' className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.8)' : 'unset' }}>
        <div className='row col-12'>
          <SectionEventNewspaper
            bannerInews={bannerInews}
            ads={ads}
            //! DATALAYER
            eventDataLayer={{
              type: DATALAYER_TYPE.TRACK_POSITION,
              router: router?.pathname,
              section: 'section-spacial',
              position: 'บน:footer'
            }}
          />
        </div>
      </SectionNewsPapaerWrapper>
    </>
  );
};

const SectionNewsPapaerWrapper = styled.section`
  .row {
    margin-right: 0;
    margin-left: 0;
  }
`;

export default SectionFive;
